module.exports = __webpack_public_path__ + "img/user-bg.2f78c271.png";